import { create } from "zustand";
import { persist } from "zustand/middleware";
import { FormState } from "./types";

/**
 * Form store for managing form state
 * Persists form data in localStorage
 */
const useFormStore = create<FormState>()(
  persist(
    (set) => ({
      forms: [],
      removeForm: (formId) =>
        set((state) => ({
          forms: state.forms.filter((form) => form.id !== formId),
        })),
      updateForm: (formId, updates) =>
        set((state) => ({
          forms: state.forms.map((form) =>
            form.id === formId ? { ...form, ...updates } : form
          ),
        })),
      setForms: (forms) => set({ forms }),
      resetForms: () => set({ forms: [] }),
    }),
    {
      name: "form-store",
    }
  )
);

export default useFormStore;
